module.exports = __webpack_public_path__ + "static/media/sign.7f333d7d.svg";